const isEmpty = (obj) => {
  return !Object.keys(obj).length;
};

export default {
  isEmpty,
};
